<template>
  <div class="content-wrapper">
    <div class="flex mb-4 overflow-visible">
      <div class="lg:w-full w-full bg-grid-color h-12 overflow-visible">
        <vs-card class="px-5 py-5 overflow-visible" ref="target">
          <div class="sticky-menu p-0 py-2" :class="{ sticking }">
            <div class="d-flex justify-between align-items-center">
              <div>
                <vs-button
                  class="mr-3 mb-2 px-12"
                  @click="validateForm"
                  size="large"
                  >Save
                </vs-button>
              </div>
              <div>
                <vs-button
                  class="mr-3 mb-2 px-12"
                  @click="formDetailDialog = true"
                  size="medium"
                  >Edit Form Detail
                </vs-button>
                <vs-button
                  class="mr-3 mb-2 px-12"
                  @click="addQDialog = true"
                  size="medium"
                  >Quick add questions
                </vs-button>
              </div>
            </div>
          </div>

          <vs-input
            v-model="form_title"
            class="mb-5  w-100 form-title"
            :placeholder="`Form Title`"
            block
            size="large"
          ></vs-input>

          <vs-input
            v-model="form_description"
            class="mb-5  w-100"
            :placeholder="`Form Description`"
            block
          ></vs-input>

          <hr />

          <div class="overflow-visible">
            <div class="tab-text overflow-visible">
              <draggable
                v-model="questions"
                :options="{
                  animation: 300,
                  handle: '.drag-handle'
                }"
                tag="div"
                ghost-class="ghost"
              >
                <div
                  v-for="(question, index) in questions"
                  :key="
                    `${index}:${question.question_title}:${questions[index].description_enabled}`
                  "
                >
                  <transition name="list" tag="div">
                    <div
                      v-if="questions[index].show"
                      class="question-item d-flex align-items-start position-relative pr-20"
                      style="background: #ffffffe3; border-radius: 0.5rem"
                    >
                      <Question
                        v-model="questions[index]"
                        :allQuestions="questions"
                        :onNewQuestion="
                          () => {
                            addQuestion(index);
                          }
                        "
                        :onCopyQuestion="
                          () => {
                            copyQuestion(index);
                          }
                        "
                        :onAddTitleDescription="
                          () => {
                            addTitleDescription(index);
                          }
                        "
                        :onAddDivider="
                          () => {
                            addDivider(index);
                          }
                        "
                        :onAddImage="
                          () => {
                            addImage(index);
                          }
                        "
                        :onAddVideo="
                          () => {
                            addVideo(index);
                          }
                        "
                        :onDelete="
                          () => {
                            showDeleteDialog(index);
                          }
                        "
                        :onMoveUp="
                          () => {
                            moveQuestionUp(index);
                          }
                        "
                        :onMoveDown="
                          () => {
                            moveQuestionDown(index);
                          }
                        "
                      ></Question>
                      <!-- 3 dots icon with tooltip menu -->
                      <EllipsisMenu
                        v-if="
                          !['divider', 'title_description'].includes(
                            questions[index].question_type
                          )
                        "
                        class="remove-question-button ml-5 mt-2"
                        :isDescriptionOn.sync="
                          questions[index].description_enabled
                        "
                        :isConditionToggle.sync="
                          questions[index].condition_enabled
                        "
                        :isConditionEnabled="
                          ['radio', 'checkbox', 'select'].includes(
                            questions[index].question_type
                          )
                        "
                        :isFilterEnabled="!!questions[index].hasFilter"
                        :onFilterClick="
                          () => {
                            openFilterDialog(index);
                          }
                        "
                        :isValidationOn="true"
                        :onValidationClick="
                          () => {
                            openValidationDialog(index);
                          }
                        "
                      />
                    </div>
                  </transition>
                  <hr />
                </div>
              </draggable>
              <!-- <QuestionComp :list="questions"></QuestionComp> -->
            </div>
            <!-- <vs-button target="_blank" color="primary" @click="addQuestion()"
              >Add Question
            </vs-button>

            <div class="vx-row pt-2 mt-0">
              <div class="vx-col col-auto ml-auto">
                <vs-button class="mr-3 mb-2" @click="validateForm"
                  >Save
                </vs-button>
              </div>
            </div> -->
          </div>
        </vs-card>
      </div>
    </div>
    <vs-popup title="Delete Question?" :active.sync="confirmDeleteDialog">
      <div style="min-height: 100px" class="m-5">
        Are you sure you want to delete the Question?
      </div>
      <vs-divider />
      <div class="text-right">
        <vs-button
          style="display: inline-block"
          class="mr-2"
          @click="removeQuestion(deleteIndex)"
          >Delete</vs-button
        >
        <vs-button
          class="mr-3 mb-2"
          type="border"
          @click="confirmDeleteDialog = false"
          >Cancel
        </vs-button>
      </div>
    </vs-popup>

    <vs-popup title="Add questions" :active.sync="addQDialog">
      <br />
      <!-- d-flex justify-around -->
      <div class="d-flex justify-between mx-5">
        <vs-button
          style="display: block"
          class=""
          @click="
            loadEvents();
            addQDialog = false;
          "
          >Clone from Previous events</vs-button
        >
        <vs-button
          style="display: block"
          class=""
          @click="
            addQuestion();
            addQDialog = false;
          "
          >Add a question</vs-button
        >
      </div>
      <div class="mx-5">
        <vs-button
          block
          class="mt-4 w-full "
          @click="
            loadSuggestedQuestions();
            addQDialog = false;
          "
          >Suggest set of questions for your event</vs-button
        >
      </div>
    </vs-popup>

    <vs-popup title="Form is not valid" :active.sync="errorDialog">
      <div class="m-1">
        {{ errorText }}
      </div>

      <br />
      <!-- d-flex justify-around -->
      <div class="d-flex justify-between mx-5">
        <vs-button style="display: block" class="" @click="loadEvents()"
          >Clone from Previous events</vs-button
        >
        <vs-button
          style="display: block"
          class=""
          @click="
            addQuestion();
            errorDialog = false;
          "
          >Add your first question</vs-button
        >
      </div>
      <div class="mx-5">
        <vs-button block class="mt-4 w-full " @click="loadSuggestedQuestions()"
          >Suggest set of questions for your event</vs-button
        >
      </div>
      <vs-divider v-if="errorText != 'No Questions added yet.'" />
      <div class="text-right">
        <vs-button
          v-if="errorText != 'No Questions added yet.'"
          style="display: inline-block"
          class=""
          @click="errorDialog = false"
          >OK</vs-button
        >
      </div>
    </vs-popup>

    <vs-popup
      title="Clone questions from Previous events"
      :active.sync="cloneDialog"
    >
      <div class="m-1">
        Select a event to clone questions.
      </div>
      <div>
        <v-select
          v-model="selectedEventToClone"
          :options="eventList"
          style="min-width: 300px"
          placeholder="Select a event"
          :searchable="false"
          @input="loadOtherEventForm()"
        ></v-select>
      </div>

      <br />

      <vs-divider />
      <div class="text-right">
        <vs-button
          style="display: inline-block"
          class="mr-2"
          @click="cloneQuestion()"
          :disabled="!selectedEventQuestion"
          >Clone Questions</vs-button
        >
        <vs-button class="mr-3 mb-2" type="border" @click="cloneDialog = false"
          >Cancel
        </vs-button>
      </div>
    </vs-popup>

    <vs-popup
      title="Suggest set of questions for your event"
      :active.sync="suggestedDialog"
      class="suggested-popup"
    >
      <div class="m-1">
        Select a suggested questions to add.
      </div>
      <div>
        <v-select
          v-model="selectedSuggestedQuestion"
          :options="suggestedQuestionList"
          style="min-width: 300px"
          placeholder="Select a question"
          :searchable="false"
        ></v-select>
      </div>

      <br />

      <vs-divider />
      <div class="text-right">
        <vs-button
          style="display: inline-block"
          class="mr-2"
          @click="addSuggestedQuestion()"
          :disabled="!selectedSuggestedQuestion"
          >Add the question</vs-button
        >
        <vs-button
          class="mr-3 mb-2"
          type="border"
          @click="suggestedDialog = false"
          >Cancel
        </vs-button>
      </div>
    </vs-popup>

    <vs-popup title="Form update" :active.sync="successDialog">
      <div class="m-1">
        {{ successText }}
      </div>
      <vs-divider />
      <div class="text-right">
        <vs-button
          style="display: inline-block"
          class=""
          @click="successDialog = false"
          >OK</vs-button
        >
      </div>
    </vs-popup>
    <question-dialog
      :showDialog="questionDialog"
      :form_id="form_id"
      :event_id="event_id"
      @close="onQuestionClose"
      @submit="onQuestionSubmit"
    ></question-dialog>
    <vs-popup
      title="Filter"
      :active.sync="FilterDialog"
      fullscreen
      class="filter-popup"
    >
      <div class="m-5">
        <!-- showTicketTypeList: [],
      hideTicketTypeList: [],
      showRoleList: [],
      hideRoleTypeList: [] -->
        <table class="table table-bordered table-striped filter-table">
          <tr>
            <td></td>
            <td>Ticket Type is</td>
            <td>Role is</td>
          </tr>
          <tr>
            <td>Show when</td>
            <td>
              <v-select
                v-model="showTicketTypeList"
                :options="showticketOptions"
                multiple
                style="min-width: 300px"
                placeholder="Show when ticket type is"
              ></v-select>
            </td>
            <td>
              <v-select
                v-model="showRoleList"
                :options="showattendeeRoleOptions"
                multiple
                style="min-width: 300px"
                placeholder="Show when role is"
              ></v-select>
            </td>
          </tr>
          <tr>
            <td>Hide when</td>
            <td>
              <v-select
                v-model="hideTicketTypeList"
                :options="hideticketOptions"
                multiple
                style="min-width: 300px"
                placeholder="Hide when ticket type is"
              ></v-select>
            </td>
            <td>
              <v-select
                v-model="hideRoleList"
                :options="hideattendeeRoleOptions"
                multiple
                style="min-width: 300px"
                placeholder="Hide when role is"
              ></v-select>
            </td>
          </tr>
        </table>
      </div>
      <vs-divider />
      <div class="text-right">
        <vs-button
          style="display: inline-block"
          class="mr-2"
          @click="submitFilter"
          >Update</vs-button
        >
        <vs-button class="mr-3 mb-2" type="border" @click="FilterDialog = false"
          >Cancel
        </vs-button>
      </div>
    </vs-popup>

    <vs-popup v-if="form" title="Form Details" :active.sync="formDetailDialog" fullscreen>
      <section>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Form Type</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <ul class="demo-alignment">
              <li v-for="type in types" :key="type">
                <vs-radio v-model="form.form_type" disabled :vs-value="type">{{
                  type
                }}</vs-radio>
              </li>
            </ul>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Form Name</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input
              v-validate="'required'"
              name="form_title"
              class="w-full"
              v-model="form.form_title"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('form_title')"
              >{{ errors.first("form_title") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Short Description</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full mb-10">
            <quill-editor
              class="editor"
              v-model="form.form_shortdesc"
              :options="editorOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
            >
              <div id="toolbar" slot="toolbar">
                <!-- Add a bold button -->
                <button class="ql-bold">Bold</button>
                <button class="ql-italic">Italic</button>
                <!-- Add font size dropdown -->
                <select class="ql-size">
                  <option value="small"></option>
                  <!-- Note a missing, thus falsy value, is used to reset to default -->
                  <option selected></option>
                  <option value="large"></option>
                  <option value="huge"></option>
                </select>
                <select class="ql-font">
                  <option selected="selected"></option>
                  <option value="serif"></option>
                  <option value="monospace"></option>
                </select>
                <!-- Add subscript and superscript buttons -->
                <button class="ql-script" value="sub"></button>
                <button class="ql-script" value="super"></button>
              </div>
            </quill-editor>
            <vs-textarea
              style="display: none"
              class="w-full"
              v-model="form.form_shortdesc"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Long Description</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full mb-10">
            <quill-editor
              class="editor"
              v-model="form.form_longdesc"
              :options="editorOption2"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
            >
              <div id="toolbar2" slot="toolbar">
                <!-- Add a bold button -->
                <button class="ql-bold">Bold</button>
                <button class="ql-italic">Italic</button>
                <!-- Add font size dropdown -->
                <select class="ql-size">
                  <option value="small"></option>
                  <!-- Note a missing, thus falsy value, is used to reset to default -->
                  <option selected></option>
                  <option value="large"></option>
                  <option value="huge"></option>
                </select>
                <select class="ql-font">
                  <option selected="selected"></option>
                  <option value="serif"></option>
                  <option value="monospace"></option>
                </select>
                <!-- Add subscript and superscript buttons -->
                <button class="ql-script" value="sub"></button>
                <button class="ql-script" value="super"></button>
              </div>
            </quill-editor>
            <vs-textarea
              style="display: none"
              class="w-full"
              v-model="form.form_longdesc"
            />
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Is anonymous </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <b-form-checkbox
              v-model="form.is_anonymous"
              class="custom-control-danger"
              name="check-button"
              switch
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <label for="datepicker-start">Start</label>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <el-date-picker
              v-model="form.datetime_start"
              type="datetime"
              placeholder="Start date"
              value-format="yyyy-MM-dd HH:mm"
              format="dd-MM-yyyy HH:mm"
              :picker-options="StartPickerOptions"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>End</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <el-date-picker
              v-model="form.datetime_end"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="End date"
              format="dd-MM-yyyy HH:mm"
              :picker-options="EndPickerOptions"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Auth required</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <b-form-checkbox
              v-model="form.auth_required"
              class="custom-control-danger"
              name="check-button"
              switch
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Publish status</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <b-form-checkbox
              v-model="form.publish_status"
              class="custom-control-danger"
              name="check-button"
              switch
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>listing_status</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <b-form-checkbox
              v-model="form.listing_status"
              class="custom-control-danger"
              name="check-button"
              switch
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>weight</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="form.weight" maxlength="3" />
          </div>
        </div>
      </section>

      <div class="vx-row pt-5">
        <div class="vx-col sm:w-2/3 w-full ml-auto">
          <vs-button
            :disabled="!valid"
            class="mr-3 mb-2"
            @click.prevent="validateUpdateForm"
            >Update Form</vs-button
          >
        </div>
      </div>
    </vs-popup>
    <vs-popup
      title="Validate"
      :active.sync="validateDialog"
      fullscreen
      class="filter-popup"
    >
      <div class="m-5 mx-auto" style="width: 70%">
        <table class="table filter-table">
          <tr
            v-if="
              true ||
                (this.questions[this.validateIndex] &&
                  this.questions[this.validateIndex].question_type == 'number')
            "
          >
            <td>
              <div class="d-flex align-items-center">
                <vs-radio
                  class="mt-2"
                  v-model="validateSelect"
                  :vs-value="`minlength`"
                  style="width: 150px"
                >
                  Min Length
                </vs-radio>
                <div class="px-2 ml-3">Min:</div>
                <b-form-input
                  size="sm"
                  style="width: 80px"
                  :type="`number`"
                  v-model="validateValue.minlength"
                  :disabled="validateSelect != `minlength`"
                ></b-form-input>
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center">
                <vs-radio
                  class="mt-2"
                  style="width: 150px"
                  v-model="validateSelect"
                  :vs-value="`maxlength`"
                >
                  Max Length
                </vs-radio>
                <div class="px-2 ml-3">Max:</div>
                <b-form-input
                  size="sm"
                  style="width: 80px"
                  :type="`number`"
                  v-model="validateValue.maxlength"
                  :disabled="validateSelect != `maxlength`"
                ></b-form-input>
                <!-- <div class="px-2">Max:</div>
                <b-form-input
                  size="sm"
                  style="width: 80px"
                  :type="`number`"
                ></b-form-input> -->
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center">
                <vs-radio
                  class="mt-2"
                  style="width: 150px"
                  v-model="validateSelect"
                  :vs-value="`rangelength`"
                >
                  Range Length
                </vs-radio>
                <div class="px-2 ml-3">Min:</div>
                <b-form-input
                  size="sm"
                  style="width: 80px"
                  :type="`number`"
                  v-model="validateValue.rangelength[0]"
                  :disabled="validateSelect != `rangelength`"
                ></b-form-input>
                <div class="px-2">Max:</div>
                <b-form-input
                  size="sm"
                  style="width: 80px"
                  :type="`number`"
                  v-model="validateValue.rangelength[1]"
                  :disabled="validateSelect != `rangelength`"
                ></b-form-input>
              </div>
            </td>
          </tr>
          <tr
            v-if="
              true ||
                (this.questions[this.validateIndex] &&
                  this.questions[this.validateIndex].question_type == 'number')
            "
          >
            <td>
              <div class="d-flex align-items-center">
                <vs-radio
                  class="mt-2"
                  v-model="validateSelect"
                  :vs-value="`min`"
                  style="width: 150px"
                >
                  Min
                </vs-radio>
                <div class="px-2 ml-3">Min:</div>
                <b-form-input
                  size="sm"
                  style="width: 80px"
                  :type="`number`"
                  v-model="validateValue.min"
                  :disabled="validateSelect != `min`"
                ></b-form-input>
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center">
                <vs-radio
                  class="mt-2"
                  style="width: 150px"
                  v-model="validateSelect"
                  :vs-value="`max`"
                >
                  Max
                </vs-radio>
                <div class="px-2 ml-3">Max:</div>
                <b-form-input
                  size="sm"
                  style="width: 80px"
                  :type="`number`"
                  v-model="validateValue.max"
                  :disabled="validateSelect != `max`"
                ></b-form-input>
                <!-- <div class="px-2">Max:</div>
                <b-form-input
                  size="sm"
                  style="width: 80px"
                  :type="`number`"
                ></b-form-input> -->
              </div>
            </td>
            <!-- <td>
              <div class="d-flex align-items-center">
                <vs-radio
                  class="mt-2"
                  style="width: 150px"
                  v-model="validateSelect"
                  :vs-value="`range`"
                >
                  Range
                </vs-radio>
                <div class="px-2 ml-3">Min:</div>
                <b-form-input
                  size="sm"
                  style="width: 80px"
                  :type="`number`"
                  v-model="validateValue.range[0]"
                  :disabled="validateSelect != `range`"
                ></b-form-input>
                <div class="px-2">Max:</div>
                <b-form-input
                  size="sm"
                  style="width: 80px"
                  :type="`number`"
                  v-model="validateValue.range[1]"
                  :disabled="validateSelect != `range`"
                ></b-form-input>
              </div>
            </td> -->
          </tr>
          <!-- <tr>
            <td>
              <vs-radio v-model="validateSelect" :vs-value="`email`">
                Email
              </vs-radio>
            </td>
            <td>
              <vs-radio v-model="validateSelect" :vs-value="`url`">
                Url
              </vs-radio>
            </td>
            <td>
              <vs-radio v-model="validateSelect" :vs-value="`digits`">
                Digits
              </vs-radio>
            </td>
          </tr>
          <tr>
            <td>
              <vs-radio v-model="validateSelect" :vs-value="`date`">
                Date
              </vs-radio>
            </td>
            <td>
              <vs-radio v-model="validateSelect" :vs-value="`dateISO`">
                Date ISO
              </vs-radio>
            </td>
          </tr> -->
        </table>
      </div>
      <vs-divider />
      <div class="text-right">
        <vs-button
          style="display: inline-block"
          class="mr-2"
          @click="submitValidation"
          >Update</vs-button
        >
        <vs-button
          class="mr-3 mb-2"
          type="border"
          @click="validateDialog = false"
          >Cancel
        </vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import Service from "@/services";
import { mapState } from "vuex";
import Option from "./Option.vue";
import QuestionComp from "@/components/soldoutt/QuestionComp.vue";
import QuestionDialog from "@/components/soldoutt/QuestionDialog.vue";
import Question from "@/components/soldoutt/forms/Question.vue";
import EllipsisMenu from "@/components/EllipsisMenu.vue";
import draggable from "vuedraggable";
import vSelect from "vue-select";
const short = require("short-uuid");
const translator = short();

export default {
  components: {
    Option,
    QuestionComp,
    QuestionDialog,
    Question,
    draggable,
    EllipsisMenu,
    vSelect
  },
  props: ["form_id"],
  data() {
    const types = [
      "attendee-info",
      "post-event-survey",
      "pre-event-interest",
      "vote"
    ];
    const trueOrFalse = [
      { id: 1, name: "true" },
      { id: 0, name: "false" }
    ];
    return {
      types: types,
      anonymous: trueOrFalse,
      trueOrFalse: trueOrFalse,
      valid: true,
      editorOption: {
        modules: {
          toolbar: "#toolbar"
        }
      },
      editorOption2: {
        modules: {
          toolbar: "#toolbar2"
        }
      },

      StartPickerOptions: {},
      EndPickerOptions: {},
      form_title: "",
      form_description: "",
      questionDialog: false,
      activeTab: 0,
      form: null,
      questions: [],
      description_enabled_list: [],
      showTooltip: [],
      event_id: null,
      deleteIndex: -1,
      confirmDeleteDialog: false,
      errorDialog: false,
      cloneDialog: false,
      suggestedDialog: false,
      errorText: "",
      successDialog: false,
      successText: "",
      FilterDialog: false,
      FilterIndex: -1,
      addQDialog: false,
      formDetailDialog: false,
      products: [],
      attendee_roles: [],
      remain_quantity: 0,
      showTicketTypeList: [],
      hideTicketTypeList: [],
      showRoleList: [],
      hideRoleList: [],
      validateDialog: false,
      validateIndex: -1,
      validateSelect: "",
      validateValue: {
        minlength: "",
        maxlength: "",
        rangelength: ["", ""],
        min: "",
        max: "",
        range: ["", ""],
        digits: true
      },
      validateTypeList: [
        "minlength",
        "maxlength",
        // "rangelength",
        "min",
        "max"
        // "range",
        // "step",
        // "email",
        // "url",
        // "date",
        // "dateiso",
        // "number",
        // "digits"
      ],
      sticking: false,
      eventList: [],
      selectedEventToClone: null,
      selectedEventQuestion: null,
      selectedSuggestedQuestion: null,
      suggestedQuestionList: [
        { label: "Company", slug: "company", value: "company" },
        { label: "Position", slug: "position", value: "position" },
        { label: "Website", slug: "website", value: "website" },

        {
          label: "Facebook Page Username",
          slug: "facebook_page_username",
          value: "facebook_page_username"
        },
        { label: "LINE ID", slug: "line_id", value: "line_id" },
        { label: "National ID", slug: "national_id", value: "national_id" },
        {
          label: "Student ID Card",
          slug: "student_id_card",
          value: "student_id_card"
        },
        {
          label: "Province (Thailand)",
          slug: "province_thailand",
          value: "province_thailand"
        },
        { label: "Country", slug: "country", value: "country" },
        { label: "Birthdate", slug: "birthdate", value: "birthdate" }
      ]
    };
  },
  computed: {
    ...mapState({
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    }),
    showticketOptions() {
      return this.products
        .filter(
          item => !this.hideTicketTypeList.find(t => t.value == item.product_id)
        )
        .map(item => {
          return {
            label: item.pro_name,
            value: item.product_id
          };
        });
    },
    showattendeeRoleOptions() {
      const hiderolelist = this.hideRoleList;
      return this.attendee_roles
        .filter(item => !hiderolelist.find(t => t.value == item.name))
        .map(item => {
          return {
            label: item.name,
            value: item.name
          };
        });
    },
    hideticketOptions() {
      return this.products
        .filter(
          item => !this.showTicketTypeList.find(t => t.value == item.product_id)
        )
        .map(item => {
          return {
            label: item.pro_name,
            value: item.product_id
          };
        });
    },
    hideattendeeRoleOptions() {
      return this.attendee_roles
        .filter(item => !this.showRoleList.find(t => t.value == item.name))
        .map(item => {
          return {
            label: item.name,
            value: item.name
          };
        });
    }
  },
  created() {
    this.$vs.loading();
    setTimeout(() => {
      this.fetchData();
    }, 1000);
  },
  mounted() {
    try {
      const observer = new IntersectionObserver(
        ([entry]) => {
          this.sticking = !entry.isIntersecting;
        },
        { threshold: 0.0 }
      );
      observer.observe(this.$refs.target);
    } catch (_) {
      console.log();
    }
  },
  methods: {
    consolelog: console.log,
    jsonstrigfy: JSON.stringify,
    compareValues(key, order = "asc") {
      return function(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          return 0;
        }

        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order == "desc" ? comparison * -1 : comparison;
      };
    },
    openFilterDialog(index) {
      this.FilterIndex = index;
      this.showTicketTypeList =
        this.questions[index].filter &&
        this.questions[index].filter.include &&
        this.questions[index].filter.include.product_id
          ? this.questions[index].filter.include.product_id.map(item => {
              return this.showticketOptions.find(s => s.value == item);
            })
          : [];
      this.hideTicketTypeList =
        this.questions[index].filter &&
        this.questions[index].filter.exclude &&
        this.questions[index].filter.exclude.product_id
          ? this.questions[index].filter.exclude.product_id.map(item => {
              return this.hideticketOptions.find(s => s.value == item);
            })
          : [];
      this.showRoleList =
        this.questions[index].filter &&
        this.questions[index].filter.include &&
        this.questions[index].filter.include.role
          ? this.questions[index].filter.include.role.map(item => {
              return this.showattendeeRoleOptions.find(s => s.value == item);
            })
          : [];
      this.hideRoleTypeList =
        this.questions[index].filter &&
        this.questions[index].filter.exclude &&
        this.questions[index].filter.exclude.role
          ? this.questions[index].filter.exclude.role.map(item => {
              return this.hideattendeeRoleOptions.find(s => s.value == item);
            })
          : [];
      this.FilterDialog = true;
    },
    submitFilter() {
      if (this.showTicketTypeList.length) {
        if (!this.questions[this.FilterIndex].filter.include) {
          this.questions[this.FilterIndex].filter.include = {};
        }
        this.questions[
          this.FilterIndex
        ].filter.include.product_id = this.showTicketTypeList.map(
          item => item.value
        );
      } else if (this.questions[this.FilterIndex].filter.include && this.questions[this.FilterIndex].filter.include.product_id){
        delete this.questions[this.FilterIndex].filter.include.product_id;
      }
      if (this.showRoleList.length) {
        if (!this.questions[this.FilterIndex].filter.include) {
          this.questions[this.FilterIndex].filter.include = {};
        }
        this.questions[
          this.FilterIndex
        ].filter.include.role = this.showRoleList.map(item => item.value);
      }
      else if (this.questions[this.FilterIndex].filter.include && this.questions[this.FilterIndex].filter.include.role){
        delete this.questions[this.FilterIndex].filter.include.role;
      }
      if (this.hideTicketTypeList.length) {
        if (!this.questions[this.FilterIndex].filter.exclude) {
          this.questions[this.FilterIndex].filter.exclude = {};
        }
        this.questions[
          this.FilterIndex
        ].filter.exclude.product_id = this.hideTicketTypeList.map(
          item => item.value
        );
      }
      else if (this.questions[this.FilterIndex].filter.exclude && this.questions[this.FilterIndex].filter.exclude.product_id){
        delete this.questions[this.FilterIndex].filter.exclude.product_id;
      }
      if (this.hideRoleList.length) {
        if (!this.questions[this.FilterIndex].filter.exclude) {
          this.questions[this.FilterIndex].filter.exclude = {};
        }
        this.questions[
          this.FilterIndex
        ].filter.exclude.role = this.hideRoleList.map(item => item.value);
      } else if (this.questions[this.FilterIndex].filter.exclude && this.questions[this.FilterIndex].filter.exclude.role){
        delete this.questions[this.FilterIndex].filter.exclude.role;
      }
      if (this.questions[this.FilterIndex].filter.include&&!this.questions[this.FilterIndex].filter.include.role && !this.questions[this.FilterIndex].filter.include.product_id) {
        delete this.questions[this.FilterIndex].filter.include;
      }

      if (this.questions[this.FilterIndex].filter.exclude && (!this.questions[this.FilterIndex].filter.exclude.role && !this.questions[this.FilterIndex].filter.exclude.product_id)) {
        delete this.questions[this.FilterIndex].filter.exclude;
      }
      if (this.questions[this.FilterIndex].filter.length == 0 || !Object.keys(this.questions[this.FilterIndex].filter).length) {
        this.questions[this.FilterIndex].hasFilter = false;
      } else {
        this.questions[this.FilterIndex].hasFilter = true;
      }
      this.FilterDialog = false;
    },
    loadEvents() {
      let data = {
        s: this.s,
        page: 1
      };
      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      this.$vs.loading();
      this.errorDialog = false;
      this.selectedEventToClone = null;
      this.selectedEventQuestion = null;
      this.cloneDialog = true;

      this.upcoming = { total: 0, from: 0, to: this.perPage, page: 1 };
      this.previous = { total: 0, from: 0, to: this.perPage, page: 1 };
      Service.Event.my(params)
        .then(res => {
          let e_main_list =
            res.data.rows.filter(x => x.parent_id == null) || [];
          let e_upcoming_list =
            res.data.rows.filter(x => x.workshop_listing_status == 1) || [];

          e_upcoming_list = e_upcoming_list
            .concat(e_main_list)
            .filter(item => item.e != this.e)
            .map(item => {
              return {
                label: item.pro_name,
                value: item.e
              };
            });

          this.eventList = e_upcoming_list;
          this.$vs.loading.close();
        })
        .catch(e => {
          console.error(e);
          this.$vs.loading.close();
        });
    },
    openValidationDialog(index) {
      this.validateIndex = index;
      const validation = this.questions[index].validations || {};
      this.validateSelect =
        this.validateTypeList.find(v => !!validation[v]) || "";
      this.validateValue = {
        minlength: validation.minlength || "",
        maxlength: validation.maxlength || "",
        rangelength: [
          validation.rangelength ? validation.rangelength[0] || "" : "",
          validation.rangelength ? validation.rangelength[1] || "" : ""
        ],
        min: validation.min || "",
        max: validation.max || "",
        range: [
          validation.range ? validation.range[0] || "" : "",
          validation.range ? validation.range[1] || "" : ""
        ],
        digits: true
      };
      this.validateDialog = true;
    },
    submitValidation() {
      this.questions[this.validateIndex].validations = {};
      if (this.questions[this.validateIndex].is_required) {
        this.questions[this.validateIndex].validations["required"] = true;
      }
      if (this.questions[this.validateIndex].question_type == "email") {
        this.questions[this.validateIndex].validations["email"] = true;
      }
      if (this.validateSelect) {
        this.questions[this.validateIndex].validations[
          this.validateSelect
        ] = this.validateValue[this.validateSelect];
      }
      this.validateDialog = false;
    },
    showMenu(index) {
      // Hide all other tooltips and toggle the current one
      this.showTooltip = this.showTooltip.map((_, i) => i === index);
    },
    showDeleteDialog(index) {
      this.deleteIndex = index;
      this.confirmDeleteDialog = true;
    },
    moveQuestionUp(index) {
      if (index > 0) {
        const temp = this.questions[index];

        this.questions[index] = this.questions[index - 1];

        this.questions[index - 1] = temp;
        this.refreshQuestion();
      }
    },
    moveQuestionDown(index) {
      if (index < this.questions.length - 1) {
        const temp = this.questions[index];

        this.questions[index] = this.questions[index + 1];

        this.questions[index + 1] = temp;
        this.refreshQuestion();
      }
    },
    loadOtherEventForm() {
      if (!this.selectedEventToClone) {
        return;
      }
      this.$vs.loading();
      let data = {
        e: this.selectedEventToClone.value,
        s: this.s
      };
      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");
      Service.Question.getAttendeeInfoForm(params)
        .then(attendeeInfoRes => {
          let attendee_info_question_list = attendeeInfoRes.data.questions;

          for (let i = 0; i < attendeeInfoRes.data.questions.length; i++) {
            attendee_info_question_list[i].question_uuid = null;
            attendee_info_question_list[i].question_id = null;
          }
          this.selectedEventQuestion = attendee_info_question_list.map(item => {
            const description_enabled = !!item.question_shortdesc;
            const options = item.options_json;
            const condition_enabled =
              options &&
              options.find &&
              !!options.find(item => {
                return (
                  !!item.actions &&
                  !!item.actions.show_questions &&
                  !!item.actions.show_questions.length
                );
              });

            if (item.filter) {
              item.filter = JSON.parse(item.filter);
            }
            const hasFilter =
              item.filter &&
              ((item.filter.include && item.filter.include.product_id) ||
                (item.filter.exclude && item.filter.exclude.product_id) ||
                (item.filter.include && item.filter.include.role) ||
                (item.filter.exclude && item.filter.exclude.role));

            return {
              ...item,
              // max: max,
              options: options,
              description_enabled: description_enabled,
              condition_enabled: condition_enabled,
              show: true,
              filter: hasFilter ? item.filter : {},
              hasFilter
            };
          });
          this.$vs.loading.close();
        })
        .catch(() => {
          this.errorText = `This event has no attendee info.`;

          this.errorDialog = true;
          this.$vs.loading.close();
        });
    },
    cloneQuestion() {
      this.questions = this.selectedEventQuestion;
      this.cloneDialog = false;
    },
    loadSuggestedQuestions() {
      this.selectedSuggestedQuestion = null;
      this.suggestedDialog = true;
      this.errorDialog = false;
    },
    addSuggestedQuestion() {
      this.questions.push({
        form_id: this.form_id,
        form_uuid: this.form.form_uuid,
        question_uuid: translator.new(),
        event_id: this.event_id,
        question_title: this.selectedSuggestedQuestion.label,
        question_type: this.selectedSuggestedQuestion.value,
        listing_status: 1,
        is_required: 0,
        publish_status: true,
        page_filter: 1,
        current_round: 1,
        options: [],
        show: false
      });
      setTimeout(() => {
        this.questions[this.questions.length - 1].show = true;
      }, 150);
      this.suggestedDialog = false;
    },
    fetchData() {
      this.$vs.loading();
      let data = {
        e: this.$route.query.e,
        s: this.$route.query.s,
        perPage: 100,
        form_id: this.form_id
      };

      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      Service.Event.get(this.e || this.$route.query.e)
        .then(event => {
          this.event_id = event.data.event.event_id;
          const ticket_role_object = event.data.event.ticket_role
            ? JSON.parse(event.data.event.ticket_role)
            : {};
          const ticket_roles = Object.keys(ticket_role_object);
          this.attendee_roles = [];
          for (
            let ticket_roles_index = 0;
            ticket_roles_index < ticket_roles.length;
            ticket_roles_index++
          ) {
            this.attendee_roles.push(
              ticket_role_object[ticket_roles[ticket_roles_index]]
            );
          }
        })
        .catch(() => {
          this.$vs.loading.close();
        });

      Service.Event.getProducts(this.e || this.$route.query.e).then(
        products => {
          this.products = products.data.items || [];

          this.remain_quantity = parseInt(products.data.remain_free);
          this.products.sort(this.compareValues("weight", "desc"));
        }
      );

      Service.Question.get(this.form_id, params)
        .then(res => {
          this.form = res.data;
          this.event_id = res.data.event_id;
          this.form_title = res.data.form_title;
          this.form_description = res.data.form_shortdesc;

          Service.Question.getQuestions(params).then(res => {
            this.questions = res.data.rows.map(item => {
              // let max = null;
              // if (item.validations.length > 0) {
              //   item.validations.map((valid) => {
              //     if (valid.rule == "max") {
              //       max = valid.value;
              //     }
              //   });
              // }
              const description_enabled = !!item.question_shortdesc;
              const options = item.options_json;
              const condition_enabled =
                options &&
                options.find &&
                !!options.find(item => {
                  return (
                    !!item.actions &&
                    !!item.actions.show_questions &&
                    !!item.actions.show_questions.length
                  );
                });

              if (item.filter) {
                item.filter = JSON.parse(item.filter);
              }
              const hasFilter =
                item.filter &&
                ((item.filter.include && item.filter.include.product_id) ||
                  (item.filter.exclude && item.filter.exclude.product_id) ||
                  (item.filter.include && item.filter.include.role) ||
                  (item.filter.exclude && item.filter.exclude.role));

              return {
                ...item,
                // max: max,
                options: options,
                description_enabled: description_enabled,
                condition_enabled: condition_enabled,
                show: true,
                filter: hasFilter ? item.filter : {},
                hasFilter
              };
            });
            if (!this.questions || !this.questions.length) {
              // this.addQuestion();
              this.addQDialog = true;
            }
            this.description_enabled_list = res.data.rows.map(item => {
              const description_enabled = !!item.question_shortdesc;
              return description_enabled;
            });
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    refreshQuestion() {
      this.questions = JSON.parse(JSON.stringify(this.questions));
    },
    addQuestion(index = -1) {
      if (index == -1) {
        this.questions.push({
          form_id: this.form_id,
          form_uuid: this.form.form_uuid,
          question_uuid: translator.new(),
          event_id: this.event_id,
          question_title: "",
          question_type: "text",
          listing_status: 1,
          is_required: 0,
          publish_status: true,
          page_filter: 1,
          current_round: 1,
          options: [],
          show: false
        });
        setTimeout(() => {
          this.questions[this.questions.length - 1].show = true;
        }, 150);
      } else {
        this.questions.splice(index + 1, 0, {
          form_id: this.form_id,
          form_uuid: this.form.form_uuid,
          question_uuid: translator.new(),
          event_id: this.event_id,
          question_title: "",
          question_type: "text",
          listing_status: 1,
          is_required: 0,
          publish_status: true,
          page_filter: 1,
          current_round: 1,
          options: [],
          show: false
        });
        setTimeout(() => {
          this.questions[index + 1].show = true;
        }, 150);
      }
    },
    copyQuestion(index = -1) {
      if (index != -1) {
        this.questions.splice(index + 1, 0, {
          ...this.questions[index],
          question_id: undefined,
          question_uuid: translator.new(),
          show: false
        });
        setTimeout(() => {
          this.questions[index + 1].show = true;
        }, 150);
      }
    },
    addTitleDescription(index = -1) {
      if (index == -1) {
        this.questions.push({
          form_id: this.form_id,
          form_uuid: this.form.form_uuid,
          question_uuid: translator.new(),
          event_id: this.event_id,
          question_title: "",
          question_type: "title_description",
          listing_status: 1,
          is_required: 0,
          publish_status: true,
          page_filter: 1,
          current_round: 1,
          options: [],
          show: false
        });
        setTimeout(() => {
          this.questions[this.questions.length - 1].show = true;
        }, 150);
      } else {
        this.questions.splice(index + 1, 0, {
          form_id: this.form_id,
          form_uuid: this.form.form_uuid,
          question_uuid: translator.new(),
          event_id: this.event_id,
          question_title: "",
          question_type: "title_description",
          listing_status: 1,
          is_required: 0,
          publish_status: true,
          page_filter: 1,
          current_round: 1,
          options: [],
          show: false
        });
        setTimeout(() => {
          this.questions[index + 1].show = true;
        }, 150);
      }
    },
    addDivider(index = -1) {
      if (index == -1) {
        this.questions.push({
          form_id: this.form_id,
          form_uuid: this.form.form_uuid,
          question_uuid: translator.new(),
          event_id: this.event_id,
          question_title: "",
          question_type: "divider",
          listing_status: 1,
          is_required: 0,
          publish_status: true,
          page_filter: 1,
          current_round: 1,
          options: [],
          show: false
        });
        setTimeout(() => {
          this.questions[this.questions.length - 1].show = true;
        }, 150);
      } else {
        this.questions.splice(index + 1, 0, {
          form_id: this.form_id,
          form_uuid: this.form.form_uuid,
          question_uuid: translator.new(),
          event_id: this.event_id,
          question_title: "",
          question_type: "divider",
          listing_status: 1,
          is_required: 0,
          publish_status: true,
          page_filter: 1,
          current_round: 1,
          options: [],
          show: false
        });
        setTimeout(() => {
          this.questions[index + 1].show = true;
        }, 150);
      }
    },
    addImage(index = -1) {
      if (index == -1) {
        this.questions.push({
          form_id: this.form_id,
          form_uuid: this.form.form_uuid,
          question_uuid: translator.new(),
          event_id: this.event_id,
          question_title: "",
          question_type: "file_upload",
          listing_status: 1,
          is_required: 0,
          publish_status: true,
          page_filter: 1,
          current_round: 1,
          options: [],
          show: false
        });
        setTimeout(() => {
          this.questions[this.questions.length - 1].show = true;
        }, 150);
      } else {
        this.questions.splice(index + 1, 0, {
          form_id: this.form_id,
          form_uuid: this.form.form_uuid,
          question_uuid: translator.new(),
          event_id: this.event_id,
          question_title: "",
          question_type: "file_upload",
          listing_status: 1,
          is_required: 0,
          publish_status: true,
          page_filter: 1,
          current_round: 1,
          options: [],
          show: false
        });
        setTimeout(() => {
          this.questions[index + 1].show = true;
        }, 150);
      }
    },
    addVideo(index = -1) {
      if (index == -1) {
        this.questions.push({
          form_id: this.form_id,
          form_uuid: this.form.form_uuid,
          question_uuid: translator.new(),
          event_id: this.event_id,
          question_title: "",
          question_type: "video",
          listing_status: 1,
          is_required: 0,
          publish_status: true,
          page_filter: 1,
          current_round: 1,
          options: [],
          show: false
        });
        setTimeout(() => {
          this.questions[this.questions.length - 1].show = true;
        }, 150);
      } else {
        this.questions.splice(index + 1, 0, {
          form_id: this.form_id,
          form_uuid: this.form.form_uuid,
          question_uuid: translator.new(),
          event_id: this.event_id,
          question_title: "",
          question_type: "video",
          listing_status: 1,
          is_required: 0,
          publish_status: true,
          page_filter: 1,
          current_round: 1,
          options: [],
          show: false
        });
        setTimeout(() => {
          this.questions[index + 1].show = true;
        }, 150);
      }
    },
    descriptionEnabled(index, enable) {
      this.questions[index].description_enabled = enable;
      this.refreshQuestion();
    },
    conditionEnabled(index, enable) {
      this.questions[index].condition_enabled = enable;
      this.refreshQuestion();
    },
    openQuestionDialog() {
      this.questionDialog = true;
    },
    onQuestionClose() {
      this.questionDialog = false;
    },
    onQuestionSubmit() {
      this.questionDialog = false;
      this.fetchData();
    },
    removeQuestion(index) {
      // remove the question at the specified index
      this.confirmDeleteDialog = false;
      this.questions.splice(index, 1);
    },
    submitQuestion() {
      const form = {
        form_id: this.form_id,
        form_title: this.form_title,
        form_shortdesc: this.form_description,
        questions: this.questions.map((item, index) => {
          const target_field_list = [
            "company",
            "position",
            "website",
            "facebook_page_username",
            "line_id",
            "national_id",
            "student_id_card",
            "province-thailand",
            "country",
            "birthdate"
          ];
          if (target_field_list.includes(item.question_type)) {
            item.target_field = item.question_type;
          } else {
            item.target_field = null;
          }

          let validations = {};
          if (item.question_type == "number") {
            validations = item.validations;
          }
          if (item.is_required) {
            validations["required"] = true;
          }
          if (item.question_type == "email") {
            validations["email"] = true;
          }

          console.log("item", item, item.options);
          return {
            ...item,
            options_json:
              item.options && item.options.map
                ? item.options.map(item => {
                    return {
                      ...item,
                      text: item.value
                    };
                  })
                : item.options
                ? item.options
                : [],
            validations: validations,
            weight: this.questions.length * 100 - index * 100,
            page_filter: 1,
            current_round: 1,
            publish_status: 1,
            is_anonymous: null,
            auth_required: null
          };
        })
      };
      this.$vs.loading();
      Service.Question.updateQuestionList(form)
        .then(res => {
          if (res.success) {
            // const data = res.data;
            // const dataForm = data.form;

            // this.$vs.notify({
            //   title: "Success",
            //   text: "Update complete.",
            //   color: "success",
            // });
            this.successText = "Update complete.";
            this.successDialog = true;
          }
          this.$vs.loading.close();
        })
        .catch(err => {
          this.successText = "ERROR : " + err.error;
          this.successDialog = true;
          this.$vs.loading.close();
        });
    },
    validateUpdateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          this.submitUpdateForm();
        } else {
          // form have errors
        }
      });
    },
    submitUpdateForm() {
      this.$vs.loading();

      this.form = {
        ...this.form
      };

      Service.Question.update(this.form.form_id, this.form)
        .then(res => {
          if (res.success) {
            const data = res.data;
            const dataForm = data.form;

            this.$vs.notify({
              title: "Success",
              text: "Update complete.",
              color: "success"
            });

            this.$router.push("/forms/" + data.form.form_id);
          }
          this.$vs.loading.close();
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
          this.$vs.loading.close();
        });

      console.log("submit loading...", this.form);
    },
    validateForm() {
      let isValid = true;
      if (!this.questions.length) {
        isValid = false;
        this.errorText = `No Questions added yet.`;
      }
      for (let i = 0; i < this.questions.length; i++) {
        if (!this.questions[i].question_title) {
          isValid = false;
          this.errorText = `Question ${i + 1} is empty.`;
        }
        if (
          ["select", "radio", "checkbox"].includes(
            this.questions[i].question_type
          )
        ) {
          for (let j = 0; j < this.questions[i].options; j++) {
            if (!this.questions[i].options[j].value) {
              isValid = false;
              this.errorText = `Options of Question ${i + 1} is not valid.`;
            }
          }
        }
      }
      if (!isValid) {
        this.errorDialog = true;
      } else {
        this.submitQuestion();
      }
    }
  }
};
</script>
<style scoped>
.remove-question-button {
  cursor: pointer;
  color: red;
  margin-left: 10px;
  /* position: absolute;
  right: 5px;
  top: 0; */
  font-size: 30px;
}
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-width: 100px;
}

.tooltip-menu div {
  cursor: pointer;
  padding: 5px;
}

/* Style the 3 dots icon (you may need to adjust this based on your icon library) */
i.fas.fa-ellipsis-v {
  cursor: pointer;
}
.ghost {
  /* background: red; */
  background: #f8f8f8;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
.filter-table * {
  font-size: 1.3rem !important;
}

.sticky-menu {
  background-color: #fff;
  padding: 1rem;
  position: sticky;
  top: 62px;
  z-index: 999;
}

.sticky-menu .sticking {
  background-color: #fff;
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.3);
}
</style>

<style>
.con-vs-tabs,
.vs-card--content {
  overflow: visible !important;
}

.filter-table .vs__selected {
  font-size: 1.1rem !important;
}
.filter-popup .vs-popup {
  height: 400px !important;
}

.filter-popup .vs-popup--content {
  height: 100%;
  overflow: visible;
  position: relative;
}

.suggested-popup .vs-popup--content {
  height: 100%;
  overflow: visible;
  position: relative;
}
.vs-input--placeholder.large {
  font-size: 1.2rem;
}

div.form-title input.vs-input--input {
  font-size: 1.8rem !important;
}

div.form-title .vs-input--placeholder {
  font-size: 1.8rem;
}
</style>
